const resetPrefix = 'RESET_CARD_ISSUING_PIN';

export const GET_RESET_PIN_PAGE_START = `${resetPrefix}/GET_RESET_PIN_PAGE_START`;
export const GET_RESET_PIN_PAGE_SUCCESS = `${resetPrefix}/GET_RESET_PIN_PAGE_SUCCESS`;
export const GET_RESET_PIN_PAGE_FAIL = `${resetPrefix}/GET_RESET_PIN_PAGE_FAIL`;

export const RESET_PIN_START = `${resetPrefix}/RESET_PIN_START`;
export const RESET_PIN_SUCCESS = `${resetPrefix}/RESET_PIN_SUCCESS`;
export const RESET_PIN_FAIL = `${resetPrefix}/RESET_PIN_FAIL`;

export const RESET_ACTIVATE_PAGE_REDUX_STATE = 'RESET_ACTIVATE_PAGE_REDUX_STATE';
export const RESET_RESET_PIN_REDUX_STATE = 'RESET_RESET_PIN_REDUX_STATE';

export const RESET_PIN_REDIRECTED_START = `${resetPrefix}/RESET_PIN_REDIRECTED_START`;
export const RESET_PIN_REDIRECTED_SUCCESS = `${resetPrefix}/RESET_PIN_REDIRECTED_SUCCESS`;
export const RESET_PIN_REDIRECTED_FAIL = `${resetPrefix}/RESET_PIN_REDIRECTED_FAIL`;

export const VIEW_PIN_SHOW_PIN = `${resetPrefix}/VIEW_PIN_SHOW_PIN`;
